jQuery(document).ready(function ($) {
	$(".WORKSHOP-PAGE__info__element").on("click", function () {
		$(".WORKSHOP-PAGE__info__element")
			.removeClass("WORKSHOP-PAGE__info__element--open")
			.children(".WORKSHOP-PAGE__info__dropdown")
			.removeClass("WORKSHOP-PAGE__info__dropdown--open");
		$(this)
			.addClass("WORKSHOP-PAGE__info__element--open")
			.children(".WORKSHOP-PAGE__info__dropdown")
			.addClass("WORKSHOP-PAGE__info__dropdown--open");
	});
});
